export default "__VITE_ASSET__CVpAx6Un__"